import { MapFeature } from './features';
import { MapOpening } from './openings';

export interface RoomSnapshot {
    entrances: MapOpening[];
    features: MapFeature[];
}

export interface EditHistory<T> {
    past: T[];
    future: T[];
}

export const EMPTY_HISTORY: EditHistory<never> = { past: [], future: [] };

export function recordEdit<T>(history: EditHistory<T>, before: T): EditHistory<T> {
    return { past: [...history.past, before], future: [] };
}

export function undoEdit<T>(
    history: EditHistory<T>,
    current: T
): { history: EditHistory<T>; snapshot: T } | null {
    if (history.past.length === 0) return null;
    return {
        history: { past: history.past.slice(0, -1), future: [current, ...history.future] },
        snapshot: history.past[history.past.length - 1],
    };
}

export function redoEdit<T>(
    history: EditHistory<T>,
    current: T
): { history: EditHistory<T>; snapshot: T } | null {
    if (history.future.length === 0) return null;
    const [next, ...rest] = history.future;
    return {
        history: { past: [...history.past, current], future: rest },
        snapshot: next,
    };
}
